export default __webpack_public_path__ + "static/media/5.c0d8b18c.jpg";